import React, { Component } from 'react';

import Constants from '../../Constants';

import '../../styles/modals/FeedbackModal.css';

// Feedback arrives by email rather than through a form, so this is the address
// and the invitation to use it.
class FeedbackModal extends Component {
  render() {
    return (
      <div className="feedback-modal">
        <div className="feedback-modal-title">
          Leave Feedback
        </div>
        <div className="feedback-modal-paragraph">
          Have an idea, found a bug, or just want to say hi? I'd love to hear from you! Email me at:
        </div>
        <a className="feedback-modal-email" href={`mailto:${Constants.FEEDBACK_EMAIL}`}>
          {Constants.FEEDBACK_EMAIL}
        </a>

        <button className="feedback-modal-close" onClick={this.props.onClose}>
          Close
        </button>
      </div>
    );
  }
}

export default FeedbackModal;
